<template>
    <div ref="chart" style="width: 1000px; height: 100%;"></div>
</template>
  
<script>
import * as echarts from 'echarts/core';
import { GraphicComponent } from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';

export default {
    name: 'EChartsComponent',
    mounted() {
        echarts.use([GraphicComponent, CanvasRenderer]);

        var myChart = echarts.init(this.$refs.chart);
        var option = {
            graphic: {
                elements: [
                    {
                        type: 'text',
                        left: 'center',
                        top: 'center',
                        style: {
                            text: '课程管理',
                            fontSize: 65,
                            fontWeight: 'bold',
                            lineDash: [0, 200],
                            lineDashOffset: 0,
                            fill: 'transparent',
                            stroke: '#fff',
                            lineWidth: 1
                        },
                        keyframeAnimation: {
                            duration: 3000,
                            loop: true,
                            keyframes: [
                                {
                                    percent: 0.7,
                                    style: {
                                        fill: 'transparent',
                                        lineDashOffset: 200,
                                        lineDash: [200, 0]
                                    }
                                },
                                {
                                    // Stop for a while.
                                    percent: 0.8,
                                    style: {
                                        fill: 'transparent'
                                    }
                                },
                                {
                                    percent: 1,
                                    style: {
                                        fill: 'white'
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        };

        option && myChart.setOption(option);
    }
}
</script>
  
<style scoped></style>